<script>
export default {
  render(createElement) {
    const getElementData = {
      tooltip: { tag: 'b-tooltip', data: this.getTooltipData },
      normal: { tag: 'span', data: () => ({}) },
    }

    const data = getElementData[this.type].data()
    return createElement(getElementData[this.type].tag, data, this.label)
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipCustomClasses: ['no-arrow', 'tooltip-label', 'bg-primary'],
    }
  },
  updated() {
    this.$children.forEach(this.tooltipEvent)
  },
  methods: {
    getTooltipData() {
      return {
        attrs: {
          show: this.show,
          container: this.target,
          placement: 'right',
          target: this.target,
        },
        class: {
          'no-arrow': true,
          'tooltip-label': true,
          'bg-primary': true,
        },
      }
    },
    tooltipEvent(vnode) {
      vnode &&
        vnode.$on('shown', ({ target: $el }) => {
          const sidebarEl =
            $el && $el.closest('.sidebar-menu')
              ? $el.closest('.sidebar-menu')
              : undefined
          const tooltips = sidebarEl
            ? sidebarEl.querySelectorAll(`#${this.target} .tooltip`)
            : undefined
          tooltips && [...tooltips].map(tooltip => this.addCustomClass(tooltip))
        })
    },
    addCustomClass(el) {
      el &&
        this.tooltipCustomClasses.forEach(elClass => el.classList.add(elClass))
    },
  },
}
</script>

<style lang="scss">
.tooltip {
  border-radius: 4px;
}
</style>
